import * as React from "react";
import {BrowserRouter, Route, Routes } from "react-router-dom";
import {Parameter} from "./Parameter";
import {OuvrageList} from "./OuvrageList";
import Header from "./Header";

export const RootConfig: React.FC = (props) => {
    return (
        <BrowserRouter> 
            <Header/>
        <Routes>
            <Route path="/" element={<OuvrageList/>}/>
            <Route path="/parametre" element={<Parameter/>}/>
        </Routes>
        </BrowserRouter>
    )
};
